import login from './login'
import logout from './logout'
import errors from './errors'
import application from './application'

// const root = {
//   path: '/',
//   redirect: '/home',
// }

export default [...login, ...errors, ...logout, ...application]
